import { resolveService, HttpService } from "@reco-m/core";

import { message } from "antd";
export const defaultApprovers = [{ id: 1, name: "system" }];


export class WorkFlowProcessHttpService extends HttpService {
    constructor() {
        super('stateflow/project');
    }

    createState(data: any) {
        return this.httpPost("create-state", data);
    }

    getState(data: any) {
        return this.httpGet("state", this.resolveRequestParams(Object.assign({ viewAsCreator: true }, data)));
    }

    getParentTasks(data: any) {
        return this.httpGet("GetParentTasks", this.resolveRequestParams(data));
    }

    getStateVariables(data: any) {
        return this.httpGet("state-variables", this.resolveRequestParams(data));
    }

    transitState(data) {
        return this.httpPost(`transit-state`, data);
    }

    getStateRoutes(data) {
        return this.httpGet('getStateRoutes', this.resolveRequestParams(data));
    }
}

export class WorkOrderHttpService extends HttpService {
    constructor() {
        super("workorder/workorder");
    }

    getStatisticsByUser(data?: any) {
        return this.httpGet("statistics-by-user", this.resolveRequestParams(Object.assign({}, data, { IsStateOrder: true })));
    }

    getByUser(data?: any) {
        return this.httpGet("by-user", this.resolveRequestParams(Object.assign({}, data, { IsStateOrder: true })));
    }

    getInstitutionOrderByUser(data) {
        return this.httpGet("GetInstitutionOrderByUser", this.resolveRequestParams(data));
    }

    finish(id: number) {
        return this.httpPut(this.resolveUrl("finish", id));
    }

    refuse(data: any) {
        return this.httpPut(this.resolveUrl("withdraw"), data);
    }

    // 取消工单申请
    cancelApplay(data: any) {
        return this.httpPost("cancel/" + data.orderID, data.remark);
    }

    // 提醒管理员审核工单
    remindAdmin(data: any) {
        return this.httpPut(data.orderID + "/remind");
    }

    // 获取加载进度
    getLog(id: number) {
        return this.httpGet(id + "/logs");
    }

    getCatalogDTO(code) {
        return this.httpGet(`catalogue?catalogueCode=${code}`);
    }

    getStatisticsByCatalogue() {
        return this.httpGet("statistics-by-catalogue");
    }

    getRepairCost(data) {
        return this.httpGet(this.resolveUrl("GetRepairCost"), this.resolveRequestParams(data));
    }
}

export const workOrderService = resolveService(WorkOrderHttpService);
export const workflowProcessService = resolveService(WorkFlowProcessHttpService);

export function createFlow(code, formBind: (flowProject, projectContent) => any) {
    return new Promise((a, _b) => {
        workOrderService.getCatalogDTO(code).then(dto => {
            workflowProcessService.createState({ flowId: dto.flowId }).then(async (flowProject) => {
                const projectContent = JSON.parse(flowProject.projectContent.componentData);
                const body = await formBind(flowProject, projectContent);
                if (body.state) {
                    body.state.flowProjectId = flowProject.project.id;
                    body.state.isDefault = true;
                    body.state.isFavorite = false;
                    body.state.numbers = [];
                    body.state.opinions = [];
                    const route = flowProject.flow.process.routes.find(x => x.triggerCode === 'WorkorderSubmitTrigger');
                    if (!route) { message.error('未找到提交路由'); return; }
                    body.state.routeId = route.routeId;
                    body.state.viewAsCreator = true;
                }
                if (body.order) {
                    body.order.catalogueId = dto.catalog.id;
                    body.order.catalogueName = dto.catalog.catalogName;
                    !body.order.parkId && (body.order.parkId = localStorage.ParkID);
                    body.order.sources = "官网"
                    body.order.sourcesValue = 3;
                }

                body.state.defaultApprovers = defaultApprovers;
                workOrderService.post(body).then(workorder => {
                    a(workorder);
                }).catch((e) => {
                    alert(JSON.stringify(e));
                });
            }).catch((e) => {
                alert(JSON.stringify(e));
            })
        }).catch((e) => {
            alert(JSON.stringify(e));
        });
    })
}

export function getWorkOrderFlow(id): Promise<any[]> {
    return new Promise((a, _b) => {
        workOrderService.get(id).then(d => {
            const projectContent = JSON.parse(d.state.projectContent.componentData);
            a([projectContent, d.state.project.id]);
        });
    })
}


export function formDataReplace(componentData: any, code, value, hidValue?) {
    if (!componentData) return;
    const control = (componentData.controls || []).find(x => x.controlCode === code);
    if (control) {
        control.value = value;
        control.hidValue = hidValue;
    }
};
